import * as React from "react";
import { useState } from "react";
import { Bell } from "react-feather";
import { BsCheck2Square, BsPaperclip, BsThermometerHalf } from "react-icons/bs";
import { useSelector } from "react-redux";
import { useConfirm } from "../../contexts/confirm.text";
import { gridSelectionProperties } from "../../contexts/enquiry-grid-selection.context";
import { GlobalModalContext } from "../../contexts/GlobalModalContext";
import { useContextMenu } from "../../hooks/useContextMenu";
import { iEnquiry, iOwner } from "../../interfaces/iEnquiry";
import { GetMailboxPermissions } from "../../interfaces/Permissions";
import { defaultGridValues, getPreference, iGridColumn, savePrefence } from "../../interfaces/preference";
import Statuses from "../../interfaces/Statuses";
import { ActivateWizardModule } from "../../Logic/Enquiries/activateWizard";
import { RootState } from "../../state/store";
import { Range } from "../../utilities/methods";
import { SortEnquiriesParams } from "../../utilities/sort";
import Confirm from "../Generic/ConfirmDialog";
import DataTable, { dataColumn } from "../Generic/DataTable";
import Grid from "../Generic/Grid";
import Pagination from "../Generic/Pagination";
import { EnquiryBurgerMenu, EnquiryContextMenu } from "../Menu";
import { GridDateTimeDisplay } from "./enquiry/enquiry";
export interface gridProps {
    data: iEnquiry[];
    theme: string;
    selectedEnquiry: number;
    columns: Array<iGridColumn>;
    sortFunction: (column: string) => {};
    sortCol: SortEnquiriesParams | undefined;
    multiSelect: boolean;
    selectedItems: string[];
    updateSelectedItems: (selectedItems: gridSelectionProperties) => void;
    dataTableId: string;
    usesPagination?: boolean;
    totalItems?: number;
    changePage?: () => void;
}
function EnquiryGrid(props: gridProps) {
    const UserPreferences = useSelector((state: RootState) => state.UserInformation.preferences);
    const permissions = useSelector((state: RootState) => state.permissions);
    const [enquiriesInUserProcessing, setEnquiriesInUserProcessing] = useState(false);
    const [displayGridHeadersProperties, setDisplayGridHeadersProperties] = useState(false);
    const { confirm } = useConfirm();
    const [shiftSelectStart, setShiftSelectStart] = useState<number>(
        props.data.findIndex(x => x.id == props.selectedEnquiry),
    ); //start index
    const [shiftSelectEnd, setShiftSelectEnd] = useState<number>(
        props.data.findIndex(x => x.id == props.selectedEnquiry),
    ); //end index
    let tempColumns: dataColumn<iEnquiry>[] = [];

    const [columns, setColumns] = useState<dataColumn<iEnquiry>[]>([]);
    React.useEffect(() => {
        getColsForGrid(props.columns);
    }, [props.columns]);

    let AllColumns: dataColumn<iEnquiry>[] = [
        {
            title: <>&nbsp;</>,
            key: "verticalSPacer",
            toolTip: "SLA",
            getData: (data: iEnquiry) => {
                switch (props.multiSelect) {
                    default: {
                        return (
                            <div
                                className="verticalBorder"
                                onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                                    e.stopPropagation();
                                    const MultiCheck = document.getElementById(
                                        "multiGrid_ch_" + data.id,
                                    ) as HTMLInputElement;
                                    if (MultiCheck) {
                                        onCheckboxClick({
                                            ...e,
                                            currentTarget: {
                                                checked: MultiCheck.checked ? false : true,
                                                value: data.id,
                                            },
                                            shiftKey: e.shiftKey,
                                            ctrlKey: e.ctrlKey,
                                        });
                                    }
                                }}
                            >
                                <div
                                    style={{
                                        height: "40px",
                                        marginTop: "-20px",
                                        marginBottom: "-40px",
                                        float: "left",
                                        marginLeft: "-6px",
                                    }}
                                >
                                    <div style={{ margin: "7px 3px 0px 5px" }}>
                                        <input
                                            type="checkbox"
                                            style={{ width: "12px", height: "12px" }}
                                            id={"multiGrid_ch_" + data.id}
                                            value={data.id}
                                            className="g-Checkbox-default"
                                            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                                e.stopPropagation();
                                                onCheckboxClick(e);
                                            }}
                                            checked={
                                                props.selectedItems.findIndex(x => x == data.id.toString()) < 0
                                                    ? false
                                                    : true
                                            }
                                        ></input>
                                    </div>
                                </div>
                            </div>
                        );
                        break;
                    }
                    case false: {
                        return (
                            <div className="verticalBorder">
                                <div
                                    style={{
                                        height: "40px",
                                        width: "8px",
                                        marginTop: "-20px",
                                        marginBottom: "-40px",
                                        float: "left",
                                        marginLeft: "-6px",
                                    }}
                                >
                                    &nbsp;
                                </div>
                            </div>
                        );
                        break;
                    }
                }
            },
            width: "20px",
            canResize: false,
            sort: undefined,
            textAlignment: "left",
            minWidth: "10px",
            visible: true,
        },
        {
            title: <BsThermometerHalf></BsThermometerHalf>,
            toolTip: "Priority",
            key: "priority",
            getData: (data: iEnquiry) => {
                return (
                    <div
                        className="sla-priority-bar"
                        style={{ marginLeft: "2px" }}
                    >
                        <div
                            style={{ height: ((255 - data.priority) / 255.0) * 100.0 + "%" }}
                            className="sla-priority--value"
                        >
                            &nbsp;
                        </div>
                    </div>
                );
            },
            width: "20px",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    props.sortFunction("priority");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "15px",
            visible: true,
        },
        {
            title: <Bell size={12}></Bell>,
            key: "hasAlarm",
            toolTip: "Alarms",
            getData: (data: iEnquiry) => {
                return data.hasAlarm == true ? <Bell size={12}></Bell> : "";
            },
            width: "18px",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    props.sortFunction("hasAlarm");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "15px",
            visible: true,
        },
        {
            title: <BsPaperclip></BsPaperclip>,
            key: "hasUnworkedAttachments",
            toolTip: "Unworked Attachments",
            getData: (data: iEnquiry) => {
                return data.hasUnworkedAttachments === true ? <BsPaperclip></BsPaperclip> : "";
            },
            width: "20px",
            canResize: false,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    props.sortFunction("hasUnworkedAttachments");
                },
                displayIcon: false,
            },
            textAlignment: "left",
            minWidth: "10px",
            visible: true,
        },

        {
            title: <>Reference</>,
            key: "enquiryReference",
            toolTip: "Reference",
            getData: (data: iEnquiry) => {
                return <span className="enquiryReference">{data.enquiryReference}</span>;
            },
            width: "130px",
            canResize: true,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    props.sortFunction("enquiryReference");
                },
                displayIcon: true,
            },
            textAlignment: "left",
            minWidth: "90px",
            visible: true,
        },
        {
            title: <>Owner</>,
            key: "owners",
            toolTip: "Owner",
            getData: (data: iEnquiry) => {
                return data.owners
                    .map(item => {
                        return `${item.lastname}, ${item.firstname}`;
                    })
                    .join("; ");
            },
            width: "20%",
            visible: true,

            canResize: true,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    props.sortFunction("owners");
                },
                displayIcon: true,
            },
            textAlignment: "left",
            minWidth: "80px",
        },
        {
            title: <>Enquirer</>,
            key: "enquirerName",
            toolTip: "Enquirer",
            getData: (data: iEnquiry) => {
                return data.enquirerName;
            },
            width: "20%",
            canResize: true,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    props.sortFunction("enquirerName");
                },
                displayIcon: true,
            },
            textAlignment: "left",
            minWidth: "80px",
            visible: true,
        },

        {
            title: <>Received</>,
            key: "dateReceived",
            toolTip: "Received",
            getData: (data: iEnquiry) => {
                return GridDateTimeDisplay(data.dateReceived);
            },
            width: "20%",
            canResize: true,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    props.sortFunction("dateReceived");
                },
                displayIcon: true,
            },
            textAlignment: "left",
            minWidth: "80px",
            visible: true,
        },
        {
            title: <>Expiry</>,
            key: "activeSlaCycle.timeout",
            toolTip: "Expiry",
            getData: (data: iEnquiry) => {
                return GridDateTimeDisplay(data.activeSlaCycle?.timeout ? data.activeSlaCycle?.timeout : "");
            },
            width: "20%",
            canResize: true,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    props.sortFunction("activeSlaCycle.timeout");
                },
                displayIcon: true,
            },
            textAlignment: "left",
            minWidth: "80px",
            visible: true,
        },

        {
            title: <>Status</>,
            key: "status",
            toolTip: "Status",
            getData: (data: iEnquiry) => {
                return Statuses.Name(data.status);
            },
            width: "35%",
            canResize: true,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    props.sortFunction("status");
                },
                displayIcon: true,
            },
            textAlignment: "left",
            minWidth: "80px",
            visible: true,
        },
        {
            title: <>Subject</>,
            key: "subject",
            toolTip: "Subject",
            getData: (data: iEnquiry) => {
                return data.subject;
            },
            width: "35%",
            canResize: true,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    props.sortFunction("subject");
                },
                displayIcon: true,
            },
            textAlignment: "left",
            minWidth: "80px",
            visible: true,
        },

        {
            title: <>Completed</>,
            key: "dateCompleted",
            toolTip: "Completed",
            getData: (data: iEnquiry) => {
                return data.dateCompleted ? GridDateTimeDisplay(data.dateCompleted) : "";
            },
            width: "20%",
            canResize: true,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    props.sortFunction("dateCompleted");
                },
                displayIcon: true,
            },
            textAlignment: "left",
            minWidth: "80px",
            visible: true,
        },
        {
            title: <>Items</>,
            key: "workItems",
            toolTip: "Items",
            getData: (data: iEnquiry) => {
                return data.workItems;
            },
            width: "50px",
            canResize: true,
            sort: {
                direction: undefined,
                sortMethod: () => {
                    props.sortFunction("workItems");
                },
                displayIcon: false,
            },
            textAlignment: "right",
            minWidth: "50px",
            maxWidth: "180px",
            visible: true,
        },
    ];

    const showModal = React.useContext(GlobalModalContext);
    const { contextMenuState, setContextMenuState, closeContextMenu } = useContextMenu();

    const getColsForGrid = (cols: Array<iGridColumn>) => {
        let filteredColumns: dataColumn<iEnquiry>[] = AllColumns.filter(x => cols.some(z => z.title == x.key)).map(
            xx => {
                return {
                    ...xx,
                    width: cols.find(c => c.title == xx.key)!.columnWidth.toString(),
                    visible: cols.find(c => c.title == xx.key)!.visible,
                };
            },
        );

        let aColumns: dataColumn<iEnquiry>[] = [];
        cols.forEach(cc => {
            if (filteredColumns.find(v => v.key == cc.title)) {
                aColumns.push(filteredColumns.find(v => v.key == cc.title)!);
            }
        });
        for (let col of aColumns) {
            if (props.sortCol && props.sortCol.orderBy == col.key) {
                if (col.sort) {
                    col.sort.direction = props.sortCol?.desc ? "desc" : "asc";
                }
            }
        }
        setColumns(aColumns);
    };

    const showDataTableContextMenu = (key: string, x: number, y: number) => {
        if (props.multiSelect) {
            if (props.selectedItems.includes(key)) {
                // if you righ click on a row and its not been selected dont show the menu
                if (
                    props.data
                        .filter(x => props.selectedItems.includes(x.id.toString()))
                        .filter(z => z.status == Statuses.Processing.ID).length == 0
                ) {
                    closeContextMenu();
                    setContextMenuState({ keys: props.selectedItems.map(x => parseInt(x)), visible: true, x: x, y: y });
                } else {
                    setEnquiriesInUserProcessing(true);
                }
            }
        } else {
            closeContextMenu();
            setContextMenuState({ keys: [parseInt(key)], visible: true, x: x, y: y });
        }
    };

    const onCheckboxClick = (itemClick: any) => {
        let sData = [...props.selectedItems];
        const newIndex = props.data.findIndex(x => x.id.toString() == itemClick.currentTarget.value);
        setShiftSelectStart(newIndex);
        setShiftSelectEnd(newIndex);
        if (itemClick.currentTarget.checked) {
            if (itemClick.shiftKey) {
                updateShiftSelection(newIndex);
            } else {
                props.updateSelectedItems({
                    multiSelect: true,
                    selectedEnquiries: sData.concat(itemClick.currentTarget.value.toString()),
                });
            }
        } else {
            props.updateSelectedItems({
                multiSelect: props.multiSelect,
                selectedEnquiries: props.selectedItems.filter(x => x != itemClick.currentTarget.value),
            });
        }
    };

    const keydownHandle = (event: React.KeyboardEvent<HTMLTableRowElement>) => {
        if (event == null) return;
        if (event.key != "ArrowUp" && event.key != "ArrowDown") return;
        let currentRow = props.data.findIndex(x => x.id.toString() == event.currentTarget.id.replace("row_", ""));
        let nextEnquiryIndex = 0;
        let sStart = shiftSelectStart,
            sEnd = shiftSelectEnd;
        if (props.multiSelect == false) {
            sStart = currentRow;
            sEnd = currentRow;
        }
        if (event.key == "ArrowUp") {
            if (sEnd <= sStart && sEnd == 0) {
                nextEnquiryIndex = 0;
            } else {
                nextEnquiryIndex = sEnd - 1;
            }
        } else {
            if (sStart <= sEnd && sEnd == props.data.length - 1) {
                nextEnquiryIndex = props.data.length - 1;
            } else {
                if (props.multiSelect) {
                    nextEnquiryIndex = sEnd + 1;
                } else {
                    nextEnquiryIndex = sStart + 1;
                }
            }
        }

        if (props.multiSelect == false) {
            if (props.selectedEnquiry != props.data[nextEnquiryIndex].id) {
                const enqModule = new ActivateWizardModule();
                enqModule.click = 0;
                enqModule.showEnquiry(props.data[nextEnquiryIndex].id);
            }
        } else {
            if (event.shiftKey == true) {
                updateShiftSelection(nextEnquiryIndex);
            }
        }
    };

    const getIdsByIndexes = (endIndex: number, startIndex: number): string[] => {
        let ids: string[] = [];
        let indexes = Range(startIndex, endIndex);
        ids = indexes.map(x => props.data[x].id.toString());
        return ids;
    };

    const updateShiftSelection = (newEndIndex: number) => {
        let currentSelectedEnquries: string[] = [];
        let previousSelectedEnquiries: string[] = [];

        previousSelectedEnquiries = getIdsByIndexes(shiftSelectStart, shiftSelectEnd);
        currentSelectedEnquries = getIdsByIndexes(shiftSelectStart, newEndIndex);

        let sData = [...props.selectedItems];
        sData = sData.filter(x => !previousSelectedEnquiries.includes(x)); // remove the enquires that were selected previously
        sData = [...new Set([...sData, ...currentSelectedEnquries])]; // merge the new selection with the previously selected items
        setShiftSelectEnd(newEndIndex);
        props.updateSelectedItems({ multiSelect: true, selectedEnquiries: sData });
    };
    const updateCtrlSelection = (item: string) => {
        let sData = [...props.selectedItems];
        if (sData.find(x => x == item)) {
            sData = sData.filter(i => i != item);
        } else {
            sData.push(item);
        }
        const newIndex = props.data.findIndex(x => x.id.toString() == item);
        setShiftSelectStart(newIndex);
        setShiftSelectEnd(newIndex);
        props.updateSelectedItems({ multiSelect: true, selectedEnquiries: sData });
    };

    const getExpiryColour = (e: iEnquiry): string => {
        let multiSelectClasses = "";
        if (props.multiSelect) {
            if (props.selectedItems.find(x => x == e.id.toString()) != undefined) {
                multiSelectClasses = "  multiSelect ";
            } else if (e.id == props.selectedEnquiry) {
                multiSelectClasses = " multiSelectActiveEnquiry ";
            }
        }
        if (e.activeSlaCycle != null && !Statuses.IsCompleted(e.status)) {
            let reminderDate = e.activeSlaCycle.reminder ? new Date(e.activeSlaCycle?.reminder) : "";
            let alarmDate = e.activeSlaCycle.alarm ? new Date(e.activeSlaCycle?.alarm) : "";
            let timeoutDate = e.activeSlaCycle.timeout ? new Date(e.activeSlaCycle?.timeout) : "";
            const currentDate = new Date();

            if (currentDate < reminderDate) {
                return " expiry-green " + multiSelectClasses;
            } else if (currentDate >= reminderDate && currentDate < alarmDate) {
                return " expiry-orange " + multiSelectClasses;
            } else if (currentDate >= alarmDate && currentDate < timeoutDate) {
                return " expiry-red " + multiSelectClasses;
            } else if (currentDate > reminderDate) {
                return " expiry-purple " + multiSelectClasses;
            } else {
                return "";
            }
        } else {
            return " expiry-none " + multiSelectClasses;
        }
    };
    const saveColWidth = (headerId: string, newColWidth: string) => {
        let pref = getPreference() as any;

        pref.grids[props.dataTableId] = pref.grids[props.dataTableId].map((x: iGridColumn) => {
            if (x.title == headerId) {
                return { ...x, columnWidth: newColWidth };
            }
            return x;
        });
        savePrefence(pref);
        getColsForGrid(pref.grids[props.dataTableId]);
    };
    const onHeaderDblClick = (id: string) => {
        const colData = (props.data as any).map((x: any) => {
            //check for "."
            let multipleCols = id.split(".");
            if (multipleCols.length == 2) {
                if (Date.parse(x[multipleCols[0]][multipleCols[1]])) {
                    return {
                        data: GridDateTimeDisplay(x[multipleCols[0]][multipleCols[1]]),
                        hasNew: x.hasNew,
                    };
                } else {
                    return {
                        data: x[multipleCols[0]][multipleCols[1]],
                        hasNew: x.hasNew,
                    };
                }
            } else {
                if (id == "status") {
                    return { data: x.hasNew ? Statuses.Name(x[id]) + " " : Statuses.Name(x[id]), hasNew: x.hasNew };
                } else if (id == "owners") {
                    let Owners: Array<iOwner> = x[id];
                    return {
                        data: Owners.map(item => {
                            return `${item.lastname}, ${item.firstname}`;
                        }).join("; "),
                        hasNew: x.hasNew,
                    };
                } else {
                    if (Date.parse(x[id])) {
                        return {
                            data: GridDateTimeDisplay(x[id]),
                            hasNew: x.hasNew,
                        };
                    } else {
                        return {
                            data: x[id],
                            hasNew: x.hasNew,
                        };
                    }
                }
            }
        });

        const longestVal = colData.reduce((longest: any, current: any) => {
            if (current.data.length > longest.data.length) {
                return current;
            } else {
                return longest;
            }
        });
        let tempDiv = document.getElementById("widthofColumn") as HTMLElement;
        let elem = document.getElementById(id) as HTMLElement;
        tempDiv.style.fontWeight = "normal";
        if (longestVal.hasNew) {
            tempDiv.style.fontWeight = "bold";
        }
        tempDiv.innerHTML = longestVal.data;
        if (elem && !isNaN(tempDiv.clientWidth)) {
            elem.style.width = tempDiv.clientWidth + 10 + "px";
            saveColWidth(id, tempDiv.clientWidth + 10 + "px");
        }
    };

    const onHeaderRightClick = () => {
        let pref = getPreference();
        setDisplayGridHeadersProperties(true);
    };
    const resetCols = async () => {
        const confirmed = await confirm({
            message: "Are you sure you want to reset the columns",
            onConfirm: () => {},
            onCancel: () => {
                setDisplayGridHeadersProperties(true);
            },
        });

        if (confirmed) {
            let pref = getPreference() as any;
            let defaultGV = defaultGridValues() as any;
            pref.grids[props.dataTableId] = defaultGV[props.dataTableId];
            savePrefence(pref);
            getColsForGrid(defaultGV[props.dataTableId]);
            setDisplayGridHeadersProperties(false);
            //  window.location.href = window.location.href;
        } else {
            setDisplayGridHeadersProperties(true);
        }
    };

    const updateColsProperties = (cols: dataColumn<iEnquiry>[]) => {
        tempColumns = cols;
    };

    function HasActivateWizardPermission(id: string): boolean {
        const enquiry = props.data.find(x => x.id.toString() == id);
        if (!enquiry) {
            return false;
        }
        return GetMailboxPermissions(permissions, enquiry.mailbox).ActionUnownedEnquiry === true &&
            enquiry.owners.length === 0
            ? GetMailboxPermissions(permissions, enquiry.mailbox).ActionUnownedEnquiry
            : GetMailboxPermissions(permissions, enquiry.mailbox).ActionOtherOwnedEnquiry === true &&
                enquiry.owners.length >= 0
              ? GetMailboxPermissions(permissions, enquiry.mailbox).ActionOtherOwnedEnquiry
              : new ActivateWizardModule().wizardPermitted(enquiry);
    }

    return (
        <>
            {columns.length > 0 ? (
                <>
                    <div style={{ float: "right", marginTop: "-40px" }}>
                        <EnquiryBurgerMenu
                            key={"burger-menu-dropdown"}
                            enquiryIds={
                                props.multiSelect
                                    ? props.selectedItems.map(x => {
                                          return parseInt(x);
                                      })
                                    : [props.selectedEnquiry]
                            }
                        ></EnquiryBurgerMenu>

                        <div
                            style={{ float: "right" }}
                            className={props.multiSelect == false ? "icon-button" : " icon-button-selected "}
                            title={props.multiSelect == false ? "Select Multiple" : "De-select Multiple"}
                            onClick={() => {
                                setShiftSelectStart(props.data.findIndex(x => x.id == props.selectedEnquiry));
                                setShiftSelectEnd(props.data.findIndex(x => x.id == props.selectedEnquiry));
                                props.updateSelectedItems({
                                    multiSelect: props.multiSelect == false ? true : false,
                                    selectedEnquiries: props.multiSelect == false ? props.selectedItems : [],
                                });
                            }}
                        >
                            <BsCheck2Square style={{ width: "14px", height: "14px" }}></BsCheck2Square>
                        </div>
                        {props.multiSelect ? (
                            <div style={{ float: "right", fontSize: "9pt", margin: "1px 5px" }}>
                                {props.selectedItems.length} selected of {props.data.length}{" "}
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    <div /** this div is used to resize grid columns to max content width*/
                        style={{ float: "left", left: "-10000000px", position: "absolute", fontSize: "10px" }}
                        id="widthofColumn"
                    >
                        sadsadsad
                    </div>
                    <div className="dataTableContainer">
                        <div className="dataTableContainer_firstRow">
                            <DataTable
                                data={props.data}
                                theme="dataTable_default"
                                dataColumns={columns}
                                uniqueIdentifiyer={x => {
                                    return x.id.toString();
                                }}
                                onRowClick={(val: string, clickEVT) => {
                                    clickEVT.stopPropagation();
                                    const newIndex = props.data.findIndex(x => x.id.toString() == val);
                                    if (props.multiSelect == false) {
                                        if (clickEVT.ctrlKey == true) {
                                            setShiftSelectStart(newIndex);
                                            setShiftSelectEnd(newIndex);
                                            props.updateSelectedItems({
                                                multiSelect: true,
                                                selectedEnquiries: [props.selectedEnquiry.toString(), val],
                                            });
                                        } else if (clickEVT.shiftKey == true) {
                                            updateShiftSelection(newIndex);
                                        } else {
                                            setShiftSelectStart(newIndex);
                                            const enqM = new ActivateWizardModule();
                                            enqM.showEnquiry(parseInt(val));
                                        }
                                    } else {
                                        switch (UserPreferences.general.enquiryList.multiSelectMode) {
                                            case "multi-preview":
                                                if (clickEVT.ctrlKey == true) {
                                                    updateCtrlSelection(val);
                                                } else if (clickEVT.shiftKey == true) {
                                                    updateShiftSelection(newIndex);
                                                } else {
                                                    setShiftSelectEnd(newIndex);
                                                    const enqM = new ActivateWizardModule();
                                                    enqM.showEnquiry(parseInt(val));
                                                }
                                                break;
                                            case "multi-standard":
                                                if (clickEVT.ctrlKey == true) {
                                                    updateCtrlSelection(val);
                                                } else if (clickEVT.shiftKey == true) {
                                                    updateShiftSelection(newIndex);
                                                } else {
                                                    const enqM = new ActivateWizardModule();
                                                    enqM.showEnquiry(parseInt(val));
                                                    props.updateSelectedItems({
                                                        multiSelect: false,
                                                        selectedEnquiries: [],
                                                    });
                                                }
                                                break;
                                        }
                                    }
                                }}
                                onRowDblClick={(x: string) => {
                                    const enqM = new ActivateWizardModule();
                                    enqM.ActivateWizard(
                                        parseInt(x),
                                        () => showModal({ type: "EnquiryLocked" }),
                                        HasActivateWizardPermission(x),
                                    );
                                }}
                                selectedItem={props.selectedEnquiry.toString()}
                                selectedItems={props.selectedItems}
                                contextMenu={showDataTableContextMenu}
                                keyPress={keydownHandle}
                                spacerRow={3}
                                getCustomClass={e => {
                                    let classes = "";

                                    classes = getExpiryColour(e);
                                    classes += !Statuses.IsCompleted(e.status) && e.hasNew ? " has-new" : "";

                                    return classes;
                                }}
                                lastItemInteracted={shiftSelectEnd}
                                saveColWidth={saveColWidth}
                                onHeaderDoubleClick={onHeaderDblClick}
                                onHeaderRightClick={onHeaderRightClick}
                            ></DataTable>
                        </div>
                        {props.usesPagination &&
                            props.totalItems &&
                            props.totalItems > parseInt(process.env.REACT_APP_ITEMS_PER_PAGE ?? "0") && (
                                <div className="dataTableContainer_secondRow">
                                    <div style={{ margin: "6px", marginLeft: "0px" }}>
                                        <Pagination
                                            numberofItems={props.totalItems ?? props.data.length}
                                            gridName={props.dataTableId}
                                            changePage={props.changePage!}
                                        />
                                    </div>
                                </div>
                            )}
                    </div>
                </>
            ) : (
                <></>
            )}
            {contextMenuState.visible && (
                <EnquiryContextMenu
                    x={contextMenuState.x}
                    y={contextMenuState.y}
                    enquiryIds={contextMenuState.keys}
                    onHide={closeContextMenu}
                />
            )}
            {enquiriesInUserProcessing && (
                <Confirm
                    title="Warning"
                    onConfirm={() => {
                        setEnquiriesInUserProcessing(false);
                    }}
                >
                    <p>
                        One or many enquiries you selected is currently in User Processing. Please deselect it to
                        perform your action.
                    </p>
                </Confirm>
            )}
            {displayGridHeadersProperties && columns.length > 0 && (
                <Confirm
                    title="Edit Column Properties"
                    onConfirm={async () => {
                        let pref = getPreference() as any;
                        if (tempColumns.length > 0) {
                            if (tempColumns.filter(c => c.visible === true).length < 5) {
                                getColsForGrid(props.columns);
                                return await confirm({
                                    message: "Please select at least one column before saving",
                                    onCancel: () => {
                                        return;
                                    },
                                });
                                return;
                            } else {
                                let transCols = tempColumns.map((x, index) => {
                                    return { title: x.key, columnWidth: x.width, visible: x.visible };
                                });
                                pref.grids[props.dataTableId] = transCols;
                                savePrefence(pref);
                                getColsForGrid(transCols);
                                setDisplayGridHeadersProperties(false);
                            }
                        } else {
                            setDisplayGridHeadersProperties(false);
                        }
                    }}
                    onCancel={() => {
                        setDisplayGridHeadersProperties(false);
                    }}
                >
                    <Grid
                        cols={columns}
                        saveCols={updateColsProperties}
                    ></Grid>
                    <br></br>
                    <div style={{ position: "relative", marginBottom: "-35px" }}>
                        <button
                            className="g-btn g-btn-alternate"
                            onClick={resetCols}
                            style={{ fontSize: "8pt" }}
                        >
                            Reset Columns
                        </button>
                    </div>
                </Confirm>
            )}
        </>
    );
}

export default EnquiryGrid;
